import { IdpLocaleMaster } from '../../models/locale-master.type';

export const defaultLocale: IdpLocaleMaster = {
  shared: {
    mypage: {
      title: 'アカウント情報',
    },
  },
} as const;
